import { gql } from '@/__generated__';

export const ACC_TYPE_CATEGORY_FRAGMENT = gql(`
  fragment AccommodationTypeCategory on accommodationType_Category {
    id
    title
    uri
  }
`);

export const PROPERTY_CARD_FRAGMENT = gql(`
  fragment PropertyCard on page_Entry {
    __typename
      id
      propertyTypeMultiple {
        ...Category
      }
      address {
        formatted
        state
        city
      }
      nBeds
      nBathrooms
      uri
      summary
      title
      featureImage {
        ...ImageAsset
      }
  }
`);
